import { create } from 'zustand'
import type { GeoLocaleResult } from './geo-locale'

interface GeoLocaleState {
  geoLocale: GeoLocaleResult | null
  geoLoading: boolean
  setGeoLocale: (result: GeoLocaleResult | null) => void
  setGeoLoading: (loading: boolean) => void
}

export const useGeoLocaleStore = create<GeoLocaleState>((set) => ({
  geoLocale: null,
  geoLoading: true,
  setGeoLocale: (result) => set({ geoLocale: result }),
  setGeoLoading: (loading) => set({ geoLoading: loading }),
}))
